import { t } from "ttag";

import { Banner, Popover, QuestionCircleIcon } from "@/shared/ui";

interface ReferralCreditBannerProps {
  label: string;
  value: number;
  detail?: string;
}

export const ReferralStatBanner = ({
  label,
  value,
  detail,
}: ReferralCreditBannerProps) => {
  return (
    <Banner.Root color="neutral">
      <Banner.Header>
        <div className="inline-flex justify-between">
          <Banner.Label>{label}</Banner.Label>

          {detail && (
            <Popover.Root>
              <Popover.Trigger className="transition-all duration-150 hover:brightness-50 active:scale-90">
                <QuestionCircleIcon className="size-4" />

                <span className="sr-only">{t`More information about ${label}`}</span>
              </Popover.Trigger>

              <Popover.Content>{detail}</Popover.Content>
            </Popover.Root>
          )}
        </div>

        <Banner.Title>${value}</Banner.Title>
      </Banner.Header>
    </Banner.Root>
  );
};
